import { useEffect, useState } from 'react';
import { A01 } from 'api/U010';

export interface Faqs {
  msgid: string;
  status: string;
  faqs: Array<Faq>;
}

export interface Faq {
  title: string | null;
  category_sort_no: number | null;
  faq_sort_no: number | null;
  faq: string | null;
  file1: string | null;
}

export function useGetFaq(lang: string): [Faqs | undefined, boolean, Error | null] {
  const [loading, setLoading] = useState<boolean>(true);
  const [faqs, setFaqs] = useState<Faqs>();
  const [err, setError] = useState<Error | null>(null);

  const fetchFaqs = async (lang: string, cancellation: AbortSignal) => {
    const json = await A01(lang, cancellation);
    return {
      msgid: json.msgid,
      status: json.status,
      faqs: json.faq,
    } satisfies Faqs;
  };

  useEffect(() => {
    const controller = new AbortController();
    const cancellation = controller.signal;
    async function fetch() {
      try {
        setLoading(true);
        setError(null);
        const faqs = await fetchFaqs(lang, cancellation);
        setFaqs(faqs);
      } catch (err) {
        console.error(err);
        setError(err instanceof Error ? err : new Error(`unknown error. ${err}`));
      } finally {
        setLoading(false);
      }
    }

    fetch();
    return () => {
      controller.abort();
    };
  }, [lang]);

  return [faqs, loading, err];
}
